import { Component, Prop, Element, h } from '@stencil/core';

@Component({
  tag: 'loading-button',
  styleUrl: 'loading-button.css',
  shadow: true,
})
export class LoadingButton {
  @Prop() hasScrollableParent: boolean = true;
  /**
   * String of text to display
   */
  @Prop() label!: string;
  /**
   * URL to icon asset
   */
  @Prop() icon!: string;
  /**
   * Disables click events
   */
  @Prop() disabled: boolean = false;
  /**
   * Disables click events and displays loading state
   */
  @Prop() loading: boolean = false;
  /**
   * onClick event handler receives a MouseEvent
   */
  @Prop() onClick: (event: MouseEvent) => void;

  @Element() el: HTMLElement;

  handleClick(event: MouseEvent) {
    if (!this.loading && this.onClick) {
      this.onClick(event);
    }
  }

  render() {
    return (
      <ripple-wrapper disabled={this.loading || this.disabled} hasScrollableParent={this.hasScrollableParent}>
        <button
          class={{
            loading: this.loading,
          }}
          disabled={this.loading || this.disabled}
          onClick={event => this.handleClick(event)}
        >
          <img src={this.icon}></img>
          <p>{this.label}</p>
        </button>
      </ripple-wrapper>
    );
  }
}
